import type { FilterSection } from '../components/filter-drawer/FilterDrawer';
import type { FilterType } from '../components/filter-drawer/FilterFactory';
import type { FacetOptionFilterState } from '../type/filter-state';

/**
 * Create facet filter sections based on aggregation and filter states.
 * @param facets The facet options to create filter sections for.
 * @returns The facet filter sections.
 */
export function createFacetFilterSections(
    facets: FacetOptionFilterState[] | undefined,
): FilterSection[] {
    if (!facets?.length) {
        return [];
    }
    // sort by isGeneral and ID
    return facets.map((facet) => {
        const filter: FilterType = {
            kind: 'SearchList',
            filterKey: 'facetOptions',
            subFilterKey: facet.id,
            props: {
                items: [],
                children: () => <div />,
                hideSearch: !facet.showSearch,
            },
        };
        return {
            title: facet.name,
            key: `facet_${facet.name}`,
            filter,
        };
    });
}
